
declare global {
    interface Window {
        _envConfig: EnvConfig;
    }
}

export interface OAuth2ClientConfig {
    keycloakUrl: string;
    realm: string;
    clientId: string;
    scope: string;
}

export enum PortalProfile {
    MV = "mv",
    MO = "mo",
}

export interface EnvConfig {
    profile: PortalProfile;
    portalUrl: string;
    serverApiUrl: string;
    serverIsdsApiUrl: string;
    oauth2: OAuth2ClientConfig;
    digitalActionMockEnabled: boolean;
}

export class EnvConfiguration {
    private constructor() {
    }

    static getConfig(): EnvConfig {
        return window._envConfig;
    }
}
